import { useMemo } from 'react';
import DataCacheService from '@/shared/services/DataCacheService';
import { getRegistrationOverviewNavParams } from '../budgetHelpers';
export var useRegistrationOverviewNavParams = function (year, relationId, invoiceStreamId, companyId) {
    return useMemo(function () {
        var _a = DataCacheService.getCompanySettings(companyId), _b = _a.budgetIncludeExForfait, budgetIncludeExForfait = _b === void 0 ? true : _b, _c = _a.budgetIncludeInForfait, budgetIncludeInForfait = _c === void 0 ? true : _c, _d = _a.budgetIncludeNotBillable, budgetIncludeNotBillable = _d === void 0 ? false : _d, _e = _a.budgetOnlyNumberedInvoices, budgetOnlyNumberedInvoices = _e === void 0 ? false : _e;
        return getRegistrationOverviewNavParams(year, relationId, invoiceStreamId, {
            includeExForfait: budgetIncludeExForfait,
            includeInForfait: budgetIncludeInForfait,
            includeNotBillable: budgetIncludeNotBillable,
            onlyNumberedInvoices: budgetOnlyNumberedInvoices,
        });
    }, [year, relationId, invoiceStreamId, companyId]);
};
